import { useTranslation } from "react-i18next";

import { useInferenceCredentialStatus } from "../../environments/primary/inferenceCredential";
import {
  currentServerToken,
  serverTokenOperatorEntry,
} from "../../environments/primary/serverToken";
import { useServerConfig } from "../../rpc/serverState";
import { useQuotaClock } from "../../useQuotaClock";
import { composerStatusItems } from "./ComposerStatus.logic";

export function ComposerStatus() {
  const { i18n } = useTranslation();
  const config = useServerConfig();
  const quotas = config?.quotas ?? null;
  const credential = useInferenceCredentialStatus((state) => state.status);
  const nowMs = useQuotaClock(quotas);
  const token = currentServerToken();
  const items = composerStatusItems({
    quotas,
    agent: config?.agent ?? null,
    credential,
    operatorEntry: token !== null && serverTokenOperatorEntry(token) !== null,
    locale: i18n.resolvedLanguage ?? i18n.language,
    nowMs,
  });
  if (items.length === 0) return null;
  return (
    <div
      role="status"
      className="mx-auto mb-3 w-full max-w-208 rounded-xl border border-amber-500/25 bg-amber-500/5 px-4 py-3 text-sm text-foreground"
    >
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.id}>{item.text}</li>
        ))}
      </ul>
    </div>
  );
}
